<template>
  <gj-table
      v-bind="$attrs"
      v-on="$listeners"
      :columns="columns"
      :data="tableData"
      :index="false"
  >
    <!-- 自定义项-->
    <!--传递的唯一标识，站点为站点id，msku为 msku-->
    <template v-for="(custom,index) in customData" v-slot:[custom.feeItemName]="{idx,row}">
      <edit-custom-fee-modal
          v-if="tabsActive === 'market' || tabsActive ==='msku'"
          :key="idx + index"
          width="100%"
          :value="row[custom.feeItemName]"
          :item="row"
          :customId="custom.id"
          :tabsActive="tabsActive"
          :marketId="row.marketId"
          :msku="row.msku"
          table-cell-edit
          align="right"
          :pop-title="'编辑费用'"
          :on-confirm="updateCustomFee">
        {{ row[custom.feeItemName] | amount | defaultShow(row.currencySymbol)}}
      </edit-custom-fee-modal>
      <span :key="idx + index" v-if="tabsActive !== 'market' && tabsActive !== 'msku'">{{ row[custom.feeItemName] | amount | defaultShow(row.currencySymbol)}}</span>
    </template>
    <!--end-->
    <template v-slot:MSKU="{ row }">
      <div class="flex">
        <gj-tooltip :content="row.msku" :text-line="1"><div class="flex1">{{ row.msku | defaultShow}}</div></gj-tooltip>
        <gj-copy-icon :content="row.msku"/>
      </div>
      <div>
        <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        <gj-copy-icon v-if="row.asin" :content="row.asin"></gj-copy-icon>
      </div>
    </template>
    <template v-slot:asin="{ row }">
      <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
      <gj-copy-icon v-if="row.asin" :content="row.asin"></gj-copy-icon>
    </template>
    <!-- 产品名称 -->
    <template v-slot:skuName="{ row }">
      <div height="100%">
        <gj-text width="90%">{{ row.productName | defaultShow}}</gj-text>
      </div>
      <div>
        {{row.sku | defaultShow}}
        <gj-copy-icon v-if="row.sku" :content="row.sku"></gj-copy-icon>
        <gj-popover-panel
          v-if="row.skuVOList && row.skuVOList.length != 0"
          :width="'200px'"
          :data="row.skuVOList | skuVOList">
        </gj-popover-panel>
      </div>
    </template>
    <!-- SKU维度产品名称 -->
    <template v-slot:SKUskuName="{ row }">
      <div height="100%">
        <gj-text width="90%">{{ row.productName | defaultShow}}</gj-text>
      </div>
      <div>
        {{row.sku | defaultShow}}
        <gj-copy-icon v-if="row.sku" :content="row.sku"></gj-copy-icon>
      </div>
    </template>
    <!-- SKU维度MSKU -->
    <template v-slot:skuMsku="{ row }">
      {{row.msku | defaultShow}}
      <gj-copy-icon v-if="row.msku" :content="row.msku"></gj-copy-icon>
      <gj-popover-panel
        v-if="row.skuVOList && row.skuVOList.length != 0"
        :width="'200px'"
        :data="row.skuVOList | skuVOList">
      </gj-popover-panel>
    </template>
    <template v-slot:alesAmount="{ row }">
      {{row.alesAmount}}
      <gj-popover-panel
          v-if="row.salesListOnePanel && row.salesListOnePanel.length != 0"
          :title="'销量详情'"
          :width="'180px'"
          :data="[row.salesListOnePanel, row.salesListTwoPanel]"
      ></gj-popover-panel>
    </template>
    <template v-slot:salesMoney="{ row }">
      {{ row.salesMoney | amount | defaultShow(row.currencySymbol) }}
      <gj-popover-panel
          v-if="row.salesMoneyListPanel && row.salesMoneyListPanel.length != 0"
          :title="'销售额详情'"
          :width="'180px'"
          :data="row.salesMoneyListPanel"
      ></gj-popover-panel>
    </template>
    <template v-slot:platformFee="{ row }">
      {{ row.platformFee | amount | defaultShow(row.currencySymbol) }}
      <gj-popover-panel
          v-if="row.platformFeeListPanel && row.platformFeeListPanel.length != 0"
          :title="'平台费详情'"
          :width="'180px'"
          :data="row.platformFeeListPanel"
      ></gj-popover-panel>
    </template>
    <template v-slot:taxes="{ row }">
      {{ row.taxes | amount | defaultShow(row.currencySymbol) }}
      <gj-popover-panel
          v-if="row.taxesListPanel && row.taxesListPanel.length != 0"
          :title="'税金详情'"
          :width="'180px'"
          :data="row.taxesListPanel"
      ></gj-popover-panel>
    </template>
    <template v-slot:promotionOtherFee="{ row }">
      {{ row.promotionOtherFee | amount | defaultShow(row.currencySymbol) }}
      <gj-popover-panel
          v-if="row.otherListPanel && row.otherListPanel.length != 0"
          :title="'其他详情'"
          :width="'180px'"
          :data="row.otherListPanel"
      ></gj-popover-panel>
    </template>
    <template v-slot:productInfo="{ row }">
      <div>
        <gj-tooltip :text-line="1" :content="row.productName">{{row.productName | defaultShow}}</gj-tooltip>
      </div>
      <el-row>
        <el-col :span="21">
          <gj-tooltip :text-line="2" :content="row.sku">
            {{row.sku || '-'}}
          </gj-tooltip>
        </el-col>
        <el-col :span="3">
          <span v-copy="row.sku"
                class="copy-icon gj-cell-display-switch">
            <gj-icon class="el-icon-copy-document"></gj-icon>
          </span>
        </el-col>
      </el-row>
    </template>
  </gj-table>
</template>

<script>
  import { updateFeeItem } from "@/api/finance"
  import {queryMixin, isMeaningfulMixin} from "@/minxins";
  import { amount } from "@/filters"

  export default {
    name: "profit-report-table-template",
    mixins: [queryMixin, isMeaningfulMixin],
    props: {
      data: {
        type: Array,
      },
      columns: {
        type: Array,
      },
      queryParams: {
        type: Object,
        default: () => ({})
      },
      customData: {
        type: Array,
        default: () => []
      },
      tabsActive:{
        type: String
      },
    },
    components: {

    },
    data() {
      return {
        tableData: [],
        useCache: false
      }
    },
    filters: {
      skuVOList(val = []) {
        if (val[0].msku) {
          return val.reduce((arr, item) => arr.concat({ label: item.marketName, value: item.msku }), [{label: '店铺国家', value: 'MSKU', bold: true}])
        }
        return val.reduce((arr, item) => arr.concat({ label: item.productName, value: item.sku }), [{label: '产品名称', value: 'SKU', bold: true}])
      }
    },
    watch: {
      data: {
        handler() {
          if (this.data && this.data.length > 0) {
            const data = Object.assign(this.data);
            data.forEach(v => {
              v.otherListPanel = this.initPanel(v.otherList, v.currencySymbol);
              v.platformFeeListPanel = this.initPanel(v.platformFeeList, v.currencySymbol);
              v.salesListOnePanel = this.initPanel(v.salesListOne, "" , true);
              v.salesListTwoPanel = this.initPanel(v.salesListTwo, "" , true);
              v.salesMoneyListPanel = this.initPanel(v.salesMoneyList, v.currencySymbol);
              v.taxesListPanel = this.initPanel(v.taxesList, v.currencySymbol);
              if (v.items && v.items.length != 0) {
                v.items.forEach(o => {
                  o.otherListPanel = this.initPanel(o.otherList, o.currencySymbol);
                  o.platformFeeListPanel = this.initPanel(o.platformFeeList, o.currencySymbol);
                  o.salesListOnePanel = this.initPanel(o.salesListOne, "" , true);
                  o.salesListTwoPanel = this.initPanel(o.salesListTwo, "" , true);
                  o.salesMoneyListPanel = this.initPanel(o.salesMoneyList, o.currencySymbol);
                  o.taxesListPanel = this.initPanel(o.taxesList, o.currencySymbol);
                })
              }
            });
            this.tableData = data;
            return;
          }
          this.tableData = [];
        },
        deep: true
      }
    },
    methods: {
      initPanel(data, prefix = '', amountNo) {
        const params = [];
        for (let key in data) {
          if (key === '小计') {
            let valueData = amountNo ? data[key] : amount(data[key])
            params.push({label: key, value: prefix + valueData, bold: true})
          } else {
            let valueData = amountNo ? data[key] : amount(data[key])
            params.push({label: key, value: prefix + valueData})
          }
        }
        return params;
      },
      // 编辑费用
      updateCustomFee(customForm,row,callback, errCallback){
        const _this = this;
        updateFeeItem(customForm).then((res)=>{
          _this.$gjMessage.success('操作成功');
          this.$emit("refresh")
          callback();
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
 /deep/.vxe-table .vxe-header--row{
  height: 28px!important;
}
/deep/ .vxe-body--row > .vxe-body--column:first-child .vxe-cell{
  padding-left: 12px;
  padding-right: 12px;
}
</style>
